import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { IDocument } from '../../Interfaces/IDocument';
import { DocumentDownloaded } from '../DocumentDownloaded';
import { ILegalClient } from '../../Interfaces/ILegalClient';

interface IPropsDownloaded {
  open: boolean;
  onClose: () => void;
  localDocumentObject: IDocument;
  assignedLegalClients: ILegalClient[];
}

export const DocumentDownloadedDialog: React.FC<IPropsDownloaded> = ({
  open,
  onClose,
  localDocumentObject,
  assignedLegalClients,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogContent>
        <DocumentDownloaded
          documentObject={localDocumentObject}
          assignedLegalClients={assignedLegalClients}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onClose}>
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
